// assets
import { IconListCheck,IconCategory, IconHelp, IconUserCheck, IconUsers } from '@tabler/icons';



// constant
const icons = { IconListCheck,IconCategory, IconHelp,IconUserCheck, IconUsers };

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

const other = {
  id: 'sample-docs-roadmap',
  type: 'group',
  children: [
    
    {
      id: 'Category',
      title: 'Category',
      type: 'item',
      url: '/category',
      icon: icons.IconCategory,
      breadcrumbs: true
    },
    {
      id: 'Buyer',
      title: 'Buyers',
      type: 'item',
      url: '/buyer',
      icon: icons.IconUserCheck,
      breadcrumbs: true
    },
    {
      id: 'Seller',
      title: 'Sellers',
      type: 'item',
      url: '/seller',
      icon: icons.IconUsers,
      breadcrumbs: true
    },
    {
      id: 'Product',
      title: 'Product',
      type: 'item',
      url: '/product',
      icon: icons.IconListCheck,
      breadcrumbs: true
    },
    {
      id: 'Orders',
      title: 'Orders History',
      type: 'item',
      url: '/orderlist',
      icon: icons.IconUsers,
      breadcrumbs: true
    },
    /*{
      id: 'documentation',
      title: 'Documentation',
      type: 'item',
      url: 'https://codedthemes.gitbook.io/berry/',
      icon: icons.IconHelp,
      external: true,
      target: true
    }*/
  ]
};

export default other;
